import { Script } from 'gatsby';
import React from 'react';

export const CookieConsentScript = () => {
    return <Script strategy="idle" src="https://cdn.wniosker.pl/js/cookie-consent.js" />;
};
